export default {
    "visits-count": "Visits count",
    "view-chart": "View chart",
    "visit-details": "Visit details",
    "distributed-materials": "Distributed materials",
    "materials": "Materials",
    "quantity": "Quantity",
    "other-materials": "Other materials",
    "duration-in-minutes": "Duration In Minutes",
    "core-message": "Core message",
    "notes": "Notes",
    "objections": "Objections",
    "next-call": "Next Call",
    "unavailable-products": "Unavailable Products",
    "competitors": "Competitors",
    "center-notes": "Center notes",
    "sort-by-classification": "Sort by classification",
    "sort-by-name": "Sort by name",
    // tabs: {
    //     all: "All",
    //     "doctor-visits": "Doctor visits",
    //     "pharmacy-visits": "Pharmacy visits",
    //     "center-visits": "Center visits"
    // },
    "samples": "Samples",
    "add-visit": "Add visit",
    "view-visit": 'View visit'
}